import { FC } from "react";

import {
	FieldLayout,
	LabelPosition,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { RHookFormNumericFormatTextField } from "../../TaxSlipDataInput/RHookFormNumericFormatTextField";

interface IEISetupFieldsPanel {}
export const EISetupFieldsPanel: FC<IEISetupFieldsPanel> = ({}) => {
	return (
		<div>
			<RHookFormNumberFieldWithLabel
				label="Max Insurable Annual Earnings"
				id="maxInsurableAnnualEarningsEi"
				testId={`Max-Insurable-Annual-Earnings`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				label="Max. Annual Premiums"
				id="maxAnnualPremiumEi"
				testId={`Max.-Annual-Premiums`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"premiumRateEi"}
				label="Premium Rate"
				testId="Premium-Rate"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"employerContributionEi"}
				label="Employer Contribution"
				testId="Employer-Contribution"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				label="Employee who has Earn Less Than"
				id="employeeWhoHasEarnLessThenEi"
				testId={`Employee-who-has-Earn-Less-Than`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
		</div>
	);
};
